// start:ng42.barrel
export * from './abmcategorias-filter.component';
// end:ng42.barrel




// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/abm/abmcategorias-filter/index.ts